module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-0 accordianheading"
  }, [_c('div', {
    staticClass: "w100 m0",
    attrs: {
      "for": "giftwrap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-8"
  }, [_c('div', {
    staticClass: "fsemibold f16"
  }, [_vm._v("Gift wrap this order\n          "), _c('small', {
    staticClass: "op_5 lightfont"
  }, [_vm._v("( ₹" + _vm._s(_vm.gwrapAmt) + " ) ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-4 text-right"
  }, [_c('div', {
    staticClass: "customcheckbox mr-15"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    on: {
      "click": function($event) {
        _vm.applygiftwrap()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v(" ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710656c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/cartWidgets.vue
// module id = 1304
// module chunks = 0 14 17